(function(){
 document.querySelectorAll('[data-jb-skin-browser]').forEach(browser=>{
   const controls=browser.querySelector('[data-jb-skin-controls]');
   const buttons=[...browser.querySelectorAll('[data-jb-skin]')];
   const cards=[...browser.querySelectorAll('[data-jb-skin-card]')];
   const counter=browser.querySelector('[data-jb-skin-count]');
   if(!controls||!cards.length)return;
   controls.hidden=false;
   function show(key){
     if(!buttons.some(button=>button.dataset.jbSkin===key))key='all';
     let count=0;
     cards.forEach(card=>{const visible=key==='all'||card.dataset.jbSkinCard.split(' ').includes(key);card.hidden=!visible;if(visible)count++;});
     buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.jbSkin===key)));
     counter.textContent=String(count)+' '+(count===1?counter.dataset.single:counter.dataset.plural);
   }
   controls.addEventListener('click',event=>{const button=event.target.closest('[data-jb-skin]');if(!button)return;show(button.dataset.jbSkin);history.replaceState(null,'','#'+button.dataset.jbSkin);});
   window.addEventListener('hashchange',()=>show(location.hash.slice(1)));
   show(location.hash.slice(1)||'all');
 });
 document.querySelectorAll('[data-jb-motion]').forEach(button=>{
   const opening=button.closest('.jb-opening');
   let paused=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   function paint(){opening.classList.toggle('is-paused',paused);button.textContent=paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-pressed',String(paused));}
   button.addEventListener('click',()=>{paused=!paused;paint();});paint();
 });
 document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.jb-header__mobile[open]').forEach(details=>{details.open=false;details.querySelector('summary').focus();});});
 document.querySelectorAll('.jb-header__mobile nav a').forEach(link=>link.addEventListener('click',()=>{link.closest('details').open=false;}));
})();
